import { useToast } from "@chakra-ui/react";

const useDeleteToast = () => {
  const toast = useToast();

  const showDeleteToast = (message = "Item deleted successfully") => {
    toast({
      title: "Deleted",
      description: message,
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top-right",
    });
  };

  return showDeleteToast;
};

export default useDeleteToast;
